import { AppDefinition } from '../../types/apps';

export const ListenAppDefinition: AppDefinition = {
  appId: 'listen-app',
  name: 'Listen',
  version: '1.0.0',
  description: 'Read documents aloud using natural text-to-speech',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'SpeakerHigh',
    phosphorWeight: 'duotone',
    color: '#8b5cf6',
  },
  supportedFileTypes: [],
  // ListenApp reads other apps' content aloud — it doesn't own Doc/Note/PDF
  // entities. Leaving this non-empty made iconService.getAppForEntityType()
  // treat ListenApp as the "owner" of those types (since Docs/Notes/PDF
  // Viewer either don't list themselves here or are matched later), handing
  // out ListenApp's SpeakerHigh icon as their entity icon.
  entityTypes: [],
  component: 'ListenApp',
  requiresProps: false,
  requiresEntity: false,
  features: [
    'Natural text-to-speech using OpenAI',
    'Multiple voice options',
    'Adjustable reading speed',
    'Support for Docs, PDFs, and Notes',
    'Mobile-optimized player interface'
  ],
  actions: {},
  experimental: true,
  hidden: true,
};






